module.exports = __webpack_public_path__ + "static/media/board.13c3a0ee.jpg";